import React, { h, Component } from 'preact';
import MenuObject from '../canvas/menu-object';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import AfterDescriptionPriceList from "./svg/AfterDescriptionPriceList";
import BinDotLeader from "./svg/BinDotLeader";
import BinDotLeaderHeader from "./svg/BinDotLeaderHeader";
import BinPriceColumn from "./svg/BinPriceColumn";
import BinPriceColumnHeader from "./svg/BinPriceColumnHeader";
import BinPricesRight from "./svg/BinPricesRight";
import BinPricesRightHeader from "./svg/BinPricesRightHeader";
import Compact from "./svg/Compact";
import CompactCenter from "./svg/CompactCenter";
import PriceDescriptionCenter from "./svg/PriceDescriptionCenter";
import PriceDescriptionLeft from "./svg/PriceDescriptionLeft";
import PriceDescriptionRight from "./svg/PriceDescriptionRight";
import PriceList from "./svg/PriceList";
import PriceListCompact from "./svg/PriceListCompact";
import PriceNameCenter from "./svg/PriceNameCenter";
import PriceNameLeft from "./svg/PriceNameLeft";
import PriceNameRight from "./svg/PriceNameRight";
import PricesRight from "./svg/PricesRight";
import PricesRightInlineTop from "./svg/PricesRightInlineTop";
import PricesRightBottom from "./svg/PricesRightBottom";
import PricesRightWithDotLeaders from "./svg/PricesRightWithDotLeaders";
import PricesRightTop from "./svg/PricesRightTop";
import Stacked from "./svg/Stacked";
import StackedLeft from "./svg/StackedLeft";
import PriceNameFloatRight from "./svg/PriceNameFloatRight";
import PriceNameFloatRightWithDotLeaders from "./svg/PriceNameFloatRightWithDotLeaders";
import PriceDescriptionFloatRight from "./svg/PriceDescriptionFloatRight";
import OneColumn from "./svg/OneColumn";
import TwoColumns from "./svg/TwoColumns";
import ThreeColumns from "./svg/ThreeColumns";
import constants, { priceColumns } from "../constants";
import util, { showDotLeaderWarningModal } from '../util';
import FourColumns from './svg/FourColumns';
import { InputNumber } from 'antd';

export default @connect(reduce, actions)
class AsideMenuObjectLayouts extends Component {
    constructor() {
        super()
        this.state = {
            objects: []
        };

        this.applyToAll = this.applyToAll.bind(this);
        this.columnsApplyToAll = this.columnsApplyToAll.bind(this);

        this.setColumns = (numColumns) => {
            MenuObject.setColumns(this.props.$element, numColumns);
        }

        this.onGapUpdate = (ev) => {
            const val = ev.target.value;
            MenuObject.setColumnGap(this.props.$element, val);
        }

        this.onColumnWidthUpdate = (index, ev) => {
            const val = parseFloat(ev.target.value);
            let columnWidths = [...(this.props.columnWidths || [])];
            
            // Initialize array with default values if empty or incomplete
            if (columnWidths.length < this.props.numColumns) {
                columnWidths = Array(this.props.numColumns).fill(100 / this.props.numColumns);
            }

            // Calculate the sum of all widths after the proposed change
            const oldVal = columnWidths[index];
            const totalSum = columnWidths.reduce((sum, width) => sum + width, 0) - oldVal + val;

            // Only proceed if the total sum would not exceed 100
            if (totalSum - 1 <= 100) {
                const difference = val - oldVal;

                // If this is the last column, adjust the previous column
                // Otherwise always adjust the last column
                const adjustmentIndex = index === columnWidths.length - 1 
                    ? columnWidths.length - 2  // Adjust previous column when changing last column
                    : columnWidths.length - 1;  // Otherwise adjust last column

                if (columnWidths[adjustmentIndex] - difference >= 10 && val >= 10) {
                    columnWidths[index] = val;
                    columnWidths[adjustmentIndex] -= difference;
                    MenuObject.setColumnWidths(this.props.$element, columnWidths);
                }
            }
        }
    }

    updateLayout(key) {
        if (key.includes("-with-dot-leaders")) {
            if (util.isSafari()) {
                showDotLeaderWarningModal();
            }
            MenuObject.updateDots(this.props.isMultiSelect ? this.props.$elements : this.props.$element, true);
            this.props.setMenuObjectDots(true);
        } else {
            this.props.setMenuObjectDots(false);
        }

        const menuObjects = this.props.$elements.filter(it => it.attr('data-component') === 'menu-object');
        MenuObject.updateLayout(this.props.isMultiSelect ? menuObjects : this.props.$element, key);
        this.props.setMenuObjectLayout(key);
    }

    getColumnSVG(numColumns, active) {
        switch (numColumns) {
            case 1:
                return <OneColumn active={active} />;
            case 2:
                return <TwoColumns active={active} />
            case 3:
                return <ThreeColumns active={active} />
            case 4:
                return <FourColumns active={active} />
            default:
                return null;
        }
    }

    getSVG(layout, active) {
        switch (layout) {
            case 'after-description-price-list':
                return <AfterDescriptionPriceList active={active} />;
            case 'bin-with-dot-leaders':
                return <BinDotLeader active={active} />;
            case 'bin-header-with-dot-leaders':
                return <BinDotLeaderHeader active={active} />;
            case 'bin-price-column':
                return <BinPriceColumn active={active} />;
            case 'bin-price-column-header':
                return <BinPriceColumnHeader active={active} />;
            case 'bin-prices-right':
                return <BinPricesRight active={active} />;
            case 'bin-prices-right-header':
                return <BinPricesRightHeader active={active} />;
            case 'compact':
                return <Compact active={active} />;
            case 'compact-center':
                return <CompactCenter active={active} />;
            case 'price-description-center':
                return <PriceDescriptionCenter active={active} />;
            case 'price-description-left':
                return <PriceDescriptionLeft active={active} />;
            case 'price-description-right':
                return <PriceDescriptionRight active={active} />;
            case 'price-list':
                return <PriceList active={active} />;
            case 'price-list-compact':
                return <PriceListCompact active={active} />;
            case 'price-name-center':
                return <PriceNameCenter active={active} />;
            case 'price-name-left':
                return <PriceNameLeft active={active} />;
            case 'price-name-right':
                return <PriceNameRight active={active} />;
            case 'prices-right':
                return <PricesRight active={active} />;
            case 'prices-right-inline-top':
                return <PricesRightInlineTop active={active} />;
            case 'prices-right-bottom':
                return <PricesRightBottom active={active} />;
            case 'prices-right-with-dot-leaders':
                return <PricesRightWithDotLeaders active={active} />;
            case 'prices-right-top':
                return <PricesRightTop active={active} />;
            case 'stacked':
                return <Stacked active={active} />;
            case 'stacked-left':
                return <StackedLeft active={active} />;
            case 'price-name-float-right':
                return <PriceNameFloatRight active={active} />
            case 'price-name-float-right-with-dot-leaders':
                return <PriceNameFloatRightWithDotLeaders active={active} />
            case 'price-description-float-right':
                return <PriceDescriptionFloatRight active={active} />
            default:
                return null;
        }
    }

    applyToAll() {
        window.ConfirmationModal.show({
            title: 'Are you sure?',
            body: 'This will apply the current layout to the entire menu.',
            acceptLabel: 'Yes, apply to all',
            declineLabel: 'Cancel',
            onAccept: () => {
                MenuObject.applyLayoutToAll(this.props.$element);
            },
            onDecline: () => {
                window.ConfirmationModal.hide()
            }
        });
    };

    columnsApplyToAll() {
        window.ConfirmationModal.show({
            title: 'Are you sure?',
            body: 'This will apply the current column settings to the entire menu.',
            acceptLabel: 'Yes, apply to all',
            declineLabel: 'Cancel',
            onAccept: () => {
                MenuObject.applyLayoutToAll(this.props.$element, MenuObject.applyModes.columns);
            },
            onDecline: () => {
                window.ConfirmationModal.hide()
            }
        });
    };

    render(props, state) {
        if (props.$element === null || Object.keys(props.menuObjectStyles).length === 0 || !MenuObject.isMenuObject(this.props.$element)) {
            return (
                <div className="menu-object-content mo-deselect-container">
                    <h2 className="mo-deselect-title">Select menu text on your design</h2>
                    <svg>
                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#mo-with-prices-tab-icon"} />
                    </svg>
                </div>
            );
        }

        const deprecatedStandardLayouts = ['price-list-compact', 'price-list', 'after-description-price-list'];
        const standardLayouts = ['price-name-left', 'price-name-float-right', 'price-name-float-right-with-dot-leaders', 'bin-with-dot-leaders', 'bin-header-with-dot-leaders', 'price-name-center', 'price-name-right', 'price-description-left', 'price-description-float-right', 'price-description-center', 'price-description-right', 'stacked', 'stacked-left', 'compact', 'compact-center'];

        const activeLayouts = MenuObject.getActiveLayouts();
        const deprecatedLayoutToKeep = $('#design-cfg').attr('deprecated-layout');
        if (deprecatedLayoutToKeep) {
            standardLayouts.push(deprecatedLayoutToKeep.trim());
        }
        activeLayouts.forEach(layout => {
            if (deprecatedStandardLayouts.includes(layout) && !standardLayouts.includes(layout.trim())) {
                standardLayouts.push(layout.trim());
            }
        });

        return (
            <div className={'aside-mo-layouts-wrapper scroller'}>
                <div className="section-header">
                    <span>Columns</span>
                    <div className={'to-all'}>
                        <a className={'btn btn-sec-sml'} onClick={this.columnsApplyToAll.bind(this)}>Apply to all</a>
                    </div>
                </div>
                <ul className="columns-icons">
                    <li className={`${props.numColumns === 1 ? 'active' : ''}`} onClick={() => this.setColumns(1)}>
                        {this.getColumnSVG(1, props.numColumns === 1)}
                    </li>
                    <li className={`${props.numColumns === 2 ? 'active' : ''} ${props.menuObjectItems.length < 2 ? 'disabled' : ''}`} onClick={() => this.setColumns(2)}>
                        {this.getColumnSVG(2, props.numColumns === 2)}
                    </li>
                    <li className={`${props.numColumns === 3 ? 'active' : ''} ${props.menuObjectItems.length < 3 ? 'disabled' : ''}`} onClick={() => this.setColumns(3)}>
                        {this.getColumnSVG(3, props.numColumns === 3)}
                    </li>
                    <li className={`${props.numColumns === 4 ? 'active' : ''} ${props.menuObjectItems.length < 4 ? 'disabled' : ''}`} onClick={() => this.setColumns(4)}>
                        {this.getColumnSVG(4, props.numColumns === 4)}
                    </li>
                </ul>

                <ul className="slider-list">
                    <li className={`slider-item ${props.numColumns === 1 ? 'inactive' : ''}`}>
                        <label className="font-spacing">Column Spacing</label>
                        <div className="toolbar-wrap">
                            <input className="slider" type="range" min="0" max="10" step="1"
                                value={props.columnGap} onChange={(ev) => this.onGapUpdate(ev)} onMouseMove={(ev) => this.onGapUpdate(ev)} />
                        </div>
                        <input className="value" type="number" min="0" max="10" step="1" disabled="disabled" value={props.columnGap} />
                    </li>
                </ul>

                {props.numColumns > 1 && (
                    <ul className="column-widths">
                        <label className="">Column Widths</label>
                        <div className="column-widths-wrapper">
                        {Array.from({length: props.numColumns}, (_, index) => (
                            <div key={index} className="column-width-item">
                                <label className="">Column {index + 1}</label>
                                <input type="number" min={10} max={100} step={1} value={props.columnWidths[index] || 100}
                                    onChange={(ev) => this.onColumnWidthUpdate(index, ev)}
                                />
                            </div>
                        ))}
                        </div>
                    </ul>
                )}

                <div className="section-header layouts-header">
                    <span>Layouts</span>
                    <div className={'to-all'}>
                        <a className={'btn btn-sec-sml'} onClick={this.applyToAll.bind(this)}>Apply to all</a>
                    </div>
                </div>
                <div className="mo-layouts">
                    <div>
                        <h5 style="margin-bottom: -20px;">Standard</h5>
                        <ul className="layouts">
                            {standardLayouts.map(layout =>
                                <li key={layout}>
                                    <a onClick={() => this.updateLayout(layout)} className={props.menuObjectLayout === layout ? 'act' : ''}>
                                        {this.getSVG(layout, props.menuObjectLayout === layout)}
                                    </a>
                                </li>)}
                        </ul>
                    </div>
                    <div className={'price-columns'}>
                        <h5 style="margin-bottom: -20px;">Price Columns</h5>
                        <ul className="layouts prices">
                            {priceColumns.map(layout =>
                                <li key={layout}>
                                    <a onClick={() => this.updateLayout(layout)} className={props.menuObjectLayout === layout ? 'act' : ''}>
                                        {this.getSVG(layout, props.menuObjectLayout === layout)}
                                    </a>
                                </li>)}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}
